export namespace Ids {
  let num = 1;
  export function nextId(prefix?: string): string {
    return (prefix || '') + (num++).toString();
  }

  // This function is exposed to be called in tests for deterministic results
  export function __testReset(): void {
    num = 1;
  }
}
